export default function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}


//////////////////
// WEBPACK FOOTER
// ../~/uncontrollable/~/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
// module id = 1348
// module chunks = 121